const LISTING_STORAGE_KEY = 'pending_listing_data';

export interface PendingListingData {
  brand: string;
  model: string;
  year: string;
  mileage: string;
  fuelType: string;
  transmission: string;
  color: string;
  price: string;
  description: string;
  location: string;
  condition: string;
  contactPhone: string;
  contactEmail: string;
  features: string[]; // <-- ADD THIS
  negotiable: boolean; // <-- ADD THIS
  imageUrls: string[];
}

export const saveListingData = (data: PendingListingData): void => {
  try {
    localStorage.setItem(LISTING_STORAGE_KEY, JSON.stringify(data));
  } catch (error) {
    console.error('Error saving listing data:', error);
  }
};

export const getListingData = (): PendingListingData | null => {
  try {
    const data = localStorage.getItem(LISTING_STORAGE_KEY);
    return data ? JSON.parse(data) : null;
  } catch (error) {
    console.error('Error retrieving listing data:', error);
    return null;
  }
};

export const clearListingData = (): void => {
  try {
    localStorage.removeItem(LISTING_STORAGE_KEY);
  } catch (error) {
    console.error('Error clearing listing data:', error);
  }
};
